export const ALERT_REQ = '@ALERT/REQ';
export const ALERT_CLOSE = '@ALERT/CLOSE';

export const ALERT_LOADING = '@ALERT/LOADING';
export const ALERT_LOADING_CLOSE = '@ALERT/LOADING_CLOSE';
